import { NgModule } from '@angular/core'
import { Route, RouterModule, UrlMatchResult, UrlSegment, UrlSegmentGroup } from '@angular/router'
import { FallbackComponent } from './fallback.component'

export function appMatcher(segments: UrlSegment[], group: UrlSegmentGroup, route: Route): UrlMatchResult {
  if (location.hostname.startsWith(route.data.app) && location.hostname.substring(route.data.app.name).match(/(-u)?\./)) {
    return {consumed: []}
  } else {
    return null
  }
}

const routes: Route[] = [
  { matcher: appMatcher, loadChildren: () => import('./apps/discovery/app/app.module').then(m => m.AppModule), data: { app: 'discovery' } },
  { matcher: appMatcher, loadChildren: () => import('./apps/dm/app/app.module').then(m => m.AppModule), data: { app: 'dm' } },
  { matcher: appMatcher, loadChildren: () => import('./apps/integrations/app/app.module').then(m => m.AppModule), data: { app: 'integrations' } },
  { matcher: appMatcher, loadChildren: () => import('./apps/reports/app/app.module').then(m => m.AppModule), data: { app: 'reports' } },
  { matcher: appMatcher, loadChildren: () => import('./apps/studio/app/app.module').then(m => m.AppModule), data: { app: 'studio' } },
  { matcher: appMatcher, loadChildren: () => import('./apps/advisor/app/app.module').then(m => m.AppModule), data: { app: 'advisor' } },
  { matcher: appMatcher, loadChildren: () => import('./apps/cfr/app/app.module').then(m => m.AppModule), data: { app: 'cfr' } },
  { matcher: appMatcher, loadChildren: () => import('./apps/leads/app/app.module').then(m => m.AppModule), data: { app: 'leads' } },
  { matcher: appMatcher, loadChildren: () => import('./apps/snapshot/app/app.module').then(m => m.AppModule), data: { app: 'snapshot' } },
  { matcher: appMatcher, loadChildren: () => import('./apps/optimize/app/app.module').then(m => m.AppModule), data: { app: 'optimize' } },
  { matcher: appMatcher, loadChildren: () => import('./apps/home/app/app.module').then(m => m.AppModule), data: { app: 'home' } },
  { path: '**', component: FallbackComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {})
  ]
})

export class AppRouterModule { }
